import { createSelector } from '@reduxjs/toolkit';

import { activePrimaryHearingSelector } from 'features/call/call-hearing/store';
import { VoiceSessionStatus } from 'features/voice-session/enums';
import { voiceSessionStatusSelector } from 'features/voice-session/store';

export const isHearingToDeafCallerLoadingSelector = createSelector(
  voiceSessionStatusSelector,
  activePrimaryHearingSelector,
  (voiceSessionStatus, activePrimaryHearing) =>
    voiceSessionStatus === VoiceSessionStatus.CONNECTING ||
    activePrimaryHearing.status === 'connecting'
);
